"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var Validator = require("validatorjs");
var utils_1 = require("./utils");
var Form = /** @class */ (function () {
    // computed
    /*
    hasErrors
    isValid
    isDirty
    isPristine
    isDefault
    isEmpty
    isFocused
    isToucehd
    isChanged
    error
    */
    function Form(submit, options) {
        this.formSchema = {};
        this.attached = false;
        this.errorMessages = undefined;
        this.attributeNames = undefined;
        this.fields = new Map();
        this.submitting = false;
        this.validating = false;
        this.snapshots = [];
        // tslint:disable-next-line:no-console
        this.externalSubmit = submit;
        this.extendConfiguration(options);
        this.registerValidation();
    }
    Object.defineProperty(Form.prototype, "snapshot", {
        get: function () {
            if (!this.snapshots.length) {
                return {};
            }
            return this.snapshots[this.snapshots.length - 1];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Form.prototype, "currentStep", {
        get: function () {
            return this.snapshots.length + 1;
        },
        enumerable: true,
        configurable: true
    });
    Form.prototype.extendConfiguration = function (options) {
        var _a = options.schema, schema = _a === void 0 ? {} : _a, _b = options.validator, validator = _b === void 0 ? {} : _b;
        var errorMessages = validator.errorMessages, attributeNames = validator.attributeNames;
        Object.assign(this.formSchema, utils_1.normalizeSchema(schema));
        this.errorMessages ? Object.assign(this.errorMessages, errorMessages) : this.errorMessages = errorMessages;
        this.attributeNames ? Object.assign(this.attributeNames, attributeNames) : this.attributeNames = attributeNames;
    };
    Object.defineProperty(Form.prototype, "isDirty", {
        get: function () {
            return Array.from(this.fields.values()).some(function (field) { return field.isDirty; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Form.prototype, "validation", {
        // todo: on for initialize values are recomputed -> this cause validation to recompute, may be inefficient
        get: function () {
            return new Validator(this.values, this.rules, this.errorMessages);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Form.prototype, "values", {
        // todo: values are recomputed each time field is registered, think if this is good behavior for form initialization
        get: function () {
            // return this.fields.entries().map(entry =>
            // ({ [entry[0]]: entry[1].value })).reduce((val, entry) => Object.assign(val, entry), {});
            return Array.from(this.fields.entries()).reduce(function (values, _a) {
                var name = _a[0], field = _a[1];
                if (field.attached) {
                    values[name] = field.value;
                }
                return values;
            }, Object.assign({}, this.snapshot));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Form.prototype, "rules", {
        get: function () {
            // todo: check if rule is computed on new field add
            // Rules are collect only for attached fields
            return Array.from(this.fields.values()).reduce(function (rules, field) {
                if (field.attached) {
                    Object.assign(rules, field.rules);
                }
                return rules;
            }, {});
        },
        enumerable: true,
        configurable: true
    });
    Form.prototype.reset = function () {
        this.fields.forEach(function (field) { return field.reset(); });
    };
    Form.prototype.setTouched = function () {
        this.fields.forEach(function (field) { return field.setTouched(); });
    };
    Form.prototype.takeSnapshot = function () {
        this.snapshots.push(Object.assign({}, this.values));
    };
    // steps (-1, -2 same like browserHistory)
    Form.prototype.restoreSnapshot = function (steps) {
        var _steps = typeof steps === 'number' ? steps : -1;
        var step = this.snapshots.length + _steps;
        if (step <= 0) {
            this.snapshots.length = 0;
        }
        else {
            this.snapshots.splice(step, Math.abs(_steps));
        }
    };
    Form.prototype.submit = function () {
        var _this = this;
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        var maybeEvent = params[0];
        // stupid assumption, but enzyme fails on check maybeEvent.nativeEvent instanceof Event
        if (maybeEvent.preventDefault) {
            maybeEvent.preventDefault();
            params.shift();
        }
        this.submitError = undefined;
        this.setTouched();
        if (!this.isValid) {
            this.submitError = this.errors.all();
            return Promise.reject(this.submitError);
        }
        this.submitting = true;
        return Promise.all([this.externalSubmit.apply(this, [this.values].concat(params))])
            .then(function (result) {
            _this.submitting = false;
            return result[0];
        }, function (error) {
            _this.submitting = false;
            _this.submitError = error;
            return Promise.reject(_this.submitError);
        });
        // todo: move into finally when it is part of standard
    };
    Form.prototype.addField = function (field) {
        this.fields.set(field.name, field);
    };
    Form.prototype.removeField = function (fieldName) {
        this.fields.get(fieldName).detach();
        this.fields.delete(fieldName);
    };
    Form.prototype.getField = function (fieldName) {
        return this.fields.get(fieldName);
    };
    Form.prototype.registerValidation = function () {
        var _this = this;
        // todo: we need to dispose this reaction
        this.validationReactionDisposer = mobx_1.reaction(function () { return _this.validation; }, function () {
            if (_this.attributeNames) {
                _this.validation.setAttributeNames(_this.attributeNames);
            }
            _this.isValid = _this.validation.passes();
            _this.errors = _this.validation.errors;
        });
    };
    Form.prototype.cleanup = function () {
        this.validationReactionDisposer();
    };
    // Field Manipulation
    Form.prototype.registerField = function (name, creationFn) {
        var fieldPath = utils_1.objectPath(name);
        var lastPathNode = fieldPath[fieldPath.length - 1];
        var fieldParent = this.getFieldParent(fieldPath);
        var field;
        if (fieldParent) {
            field = fieldParent.getField(lastPathNode);
            if (!field) {
                field = creationFn();
                fieldParent.addField(field);
            }
            else {
                field.attachCount++;
            }
        }
        return field;
    };
    Form.prototype.unregisterField = function (field) {
        if (field.attached) { // subfield may be already detached when parent detaches
            field.detach(); // to trigger disappear from rules and not cause validation error
            /* if (this.config.destroyControlStateOnUnmount) {
                    const fieldPath = objectPath(field.name),
                    lastIndex = fieldPath.length - 1,
                    lastNode = fieldPath[lastIndex],
                    fieldParent = this.getFieldParent(fieldPath);

                if (fieldParent) {
                    (fieldParent as Form | FieldArray | FieldSection).removeField(lastNode);
                }
                else {
                        console.log('Attempt to remove field on already removed parent field', field.name) // tslint:disable-line
                    }
                } */
        }
    };
    Form.prototype.findField = function (name) {
        var fieldPath = utils_1.objectPath(name);
        return this.findFieldInHierarchy(fieldPath);
    };
    Form.prototype.findFieldInHierarchy = function (path) {
        try {
            // f is Form initially, and formField after, can`t handle type error
            return path.reduce(function (f, node) { return f.getField(node); }, this);
        }
        catch (e) {
            console.error("Field can't be selected. Check name hierarchy. Probably some field on the chain does not exist", e); // tslint:disable-line
        }
    };
    Form.prototype.getFieldParent = function (path) {
        var pathToParent = path.slice(0, path.length - 1);
        return path.length === 1 ? this : this.findFieldInHierarchy(pathToParent); // tslint:disable-line
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Form.prototype, "fields", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Form.prototype, "errors", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Form.prototype, "isValid", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], Form.prototype, "submitting", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], Form.prototype, "validating", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Form.prototype, "submitError", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], Form.prototype, "snapshots", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Form.prototype, "snapshot", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Form.prototype, "currentStep", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], Form.prototype, "isDirty", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Form.prototype, "validation", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Form.prototype, "values", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Form.prototype, "rules", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Form.prototype, "reset", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Form.prototype, "setTouched", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Form.prototype, "takeSnapshot", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Form.prototype, "restoreSnapshot", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Form.prototype, "submit", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Form.prototype, "addField", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], Form.prototype, "removeField", null);
    return Form;
}());
exports.Form = Form;
//# sourceMappingURL=Form.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactive-mobx-form/lib/Form.js
// module id = 124
// module chunks = 0